import type { Copy } from "../types";

export const nl: Copy = {
    seo: {
      title: "Voertuigleeftijd calculator | controleer op jaar en maand",
      description:
        "Controleer de exacte leeftijd van een voertuig op basis van het bouwjaar en een optionele maand. Bekijk jaren, maanden, dagen, totale dagen en mijlpalen in één overzichtelijke tool.",
      keywords: [
        "voertuigleeftijd calculator",
        "auto leeftijd",
        "voertuigleeftijd per jaar",
        "bouwjaar auto",
        "productiemaand voertuig",
        "hoe oud is mijn auto",
        "controleer voertuigleeftijd",
        "RC leeftijd calculator",
        "voertuig datum calculator",
        "auto leeftijd per maand",
        "mParivahan alternatief",
        "Parivahan alternatief",
        "RTO voertuigleeftijd calculator",
        "registratieleeftijd auto controleren",
        "registratieleeftijd voertuig",
      ],
      faq: [
        {
          question: "Wat doet deze calculator?",
          answer:
            "Hij berekent de exacte leeftijd van een voertuig op basis van het gekozen bouwjaar en de optionele maand, en toont jaren, maanden, dagen en mijlpalen.",
        },
        {
          question: "Waarom is er een optionele maand?",
          answer:
            "De maand maakt de berekening nauwkeuriger. Als je geen maand kiest, gebruikt de app januari van het gekozen jaar.",
        },
        {
          question: "Kan ik een toekomstig jaar of maand kiezen?",
          answer:
            "Nee. Toekomstige jaren zijn geblokkeerd en toekomstige maanden worden uitgeschakeld wanneer het gekozen jaar het huidige jaar is.",
        },
      ],
    },
    headerTagline: "Voertuighulpmiddel",
    headerTitle: "Voertuigleeftijd Calculator",
    reset: "Reset",
    switchToLight: "Naar lichte modus",
    switchToDark: "Naar donkere modus",
    languageLabel: "Taal",
    languageEnglish: "Engels",
    languageHindi: "Hindi",
    heroEyebrow: "Autoleeftijd, duidelijk",
    heroTitle: "Een schone datumtool voor voertuigleeftijd.",
    heroDescription:
      "Selecteer het bouwjaar. Voeg alleen een maand toe als je een nauwkeuriger resultaat wilt.",
    yearSelectLabel: "Bouwjaar",
    monthSelectLabel: "Bouwmaand",
    includeMonthLabel: "Specifieke maand opnemen voor meer precisie",
    includeMonthNote:
      "Als je geen maand opneemt, wordt januari gebruikt voor de berekening.",
    yearOnlyBadge: "Alleen jaar",
    yearMonthBadge: "Jaar + maand",
    yearPlaceholder: "Selecteer jaar",
    monthPlaceholder: "Selecteer maand",
    inputTitle: "Bouwjaar",
    inputLabel: "Bouwjaar",
    blockedDateNote: "Toekomstige jaren zijn geblokkeerd.",
    result: "Resultaat",
    vehicleAgeLead: "Je voertuig is",
    asOfToday: "Per vandaag",
    years: "Jaren",
    months: "Maanden",
    days: "Dagen",
    totalDays: (count) => `${count.toLocaleString("en-IN")} dagen totaal`,
    ageLabels: {
      almostNew: "Bijna nieuw",
      modern: "Modern",
      mature: "Volwassen",
      classic: "Klassiek",
    },
    estimatedValue: {
      high: "Hoge doorverkoopkans",
      healthy: "Sterke waardebehoud",
      moderate: "Matige afschrijving",
      collector: "Verzamelaarsinteresse kan groeien",
    },
    maintenanceTitle: "Onderhoud",
    maintenance: {
      routine: "Regelmatig onderhoud en OEM-zorg",
      watch: "Let op remmen, vloeistoffen en banden",
      plan: "Plan slijtage-onderdelen en inspecties",
      specialized: "Gespecialiseerd onderhoud wordt belangrijker",
    },
    registrationTitle: "Registratie",
    registration: {
      collector: "Kan in sommige regio's als verzamelobject worden behandeld",
      classic: "Kan in sommige regio's een oldtimerregistratie krijgen",
      standard: "Reken op standaard verlengingen en regionale controles",
      regular: "Gewone registratie is meestal van toepassing",
    },
    upcomingMilestoneTitle: "Volgende mijlpaal",
    milestoneTimelineTitle: "Mijlpaaltijdlijn",
    milestoneRemaining: ({ label, days }) => `${label} over ${days.toLocaleString("nl-NL")} dagen`,
    reached: "Bereikt",
    upcoming: "Komt eraan",
    allMilestonesReachedTitle: "Alle vermelde mijlpalen zijn bereikt",
    allMilestonesReachedBody:
      "Dit voertuig is al voorbij het mijlpaalbereik dat momenteel in de app wordt getoond.",
    copySummary: "Samenvatting kopiëren",
    shareResult: "Resultaat delen",
    resetMessage: "Calculator gereset",
    summaryCopied: "Samenvatting gekopieerd naar klembord",
    clipboardFailed: "Toegang tot klembord mislukt",
    emptyTitle: "Kies een bouwjaar om de volledige details te zien",
    emptyDescription:
      "Na het kiezen van een jaar zie je de exacte leeftijd, totale dagen, onderhoudsnotities, klassieke status en mijlpalen.",
    shareTitle: "Voertuigleeftijd Calculator",
    summary: ({ label, years, months, days, asOf }) =>
      `Mijn auto is geproduceerd in ${label} en is per ${asOf} ${years} jaar, ${months} maanden en ${days} dagen oud.`,
    milestones: {
      1: { label: "Eerste jaar", note: "Handig voor garantie en serviceplanning." },
      3: { label: "Drie jaar", note: "Vaak een punt voor doorverkoop en waardeschommelingen." },
      5: { label: "Vijf jaar", note: "Goed moment om onderhoudsbudget te herzien." },
      10: { label: "Tien jaar", note: "Oudere onderdelen verdienen extra aandacht." },
      15: { label: "Vijftien jaar", note: "In veel regio's begint hier de oldtimerbehandeling." },
      25: { label: "Vijfentwintig jaar", note: "Kan aantrekkelijk zijn voor verzamelaars en importmarkten." },
    },
  };
